import { common as ptCommon } from './pt/common';
import { common as enCommon } from './en/common';
import { common as esCommon } from './es/common';

export const resources = {
  pt: {
    common: ptCommon
  },
  en: {
    common: enCommon
  },
  es: {
    common: esCommon
  }
};
